export default __webpack_public_path__ + "static/c-1000-746476691d81b8c7ec97dca7653a69b6.jpg";